import React from 'react';

import { Container } from './styles';
import CurvedSlider from './components/CurvedSlider';

type FuelLevelSelectProps = {
  handleChangeValue: (value: number | string) => void;
  fuelLevelValue: number | string | undefined;
  isError: boolean;
};

const FuelLevelSelect: React.FC<FuelLevelSelectProps> = ({
  handleChangeValue,
  fuelLevelValue,
  isError,
}) => {
  return (
    <Container>
      <CurvedSlider
        handleChangeValue={handleChangeValue}
        fuelLevelValue={fuelLevelValue}
        isError={isError}
      />
    </Container>
  );
};

export default FuelLevelSelect;
